module.exports = __webpack_public_path__ + "img/DE.7a68286b.svg";